import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CorporateOnboardingContentDto } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class CorporateOnboardingContentService {
  private readonly baseUrl = '/api/Corporate/onboarding-content';
  private readonly http = inject(HttpClient);

  getAll(): Observable<CorporateOnboardingContentDto[]> {
    return this.http.get<CorporateOnboardingContentDto[]>(`${this.baseUrl}`);
  }

  get(sectionName: string): Observable<CorporateOnboardingContentDto> {
    return this.http.get<CorporateOnboardingContentDto>(
      `${this.baseUrl}/${sectionName}`
    );
  }
}
